module.exports = require("@splunk/dashboard-visualizations/Bar");